import React from 'react';
import dayjs from 'dayjs';
import {
  ResponsiveContainer,
  CartesianGrid,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';

const BarChartComp = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { data = [], slice = 7 } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /**
   * 일자별 차트 데이터 정제
   * --
   */
  const chartData = React.useMemo(() => {
    if (!data.length) return [];

    const filterData = data.filter(
      (_item) => _item.payment_state === 'COMPLETED'
    );

    const dateData = filterData.reduce((acc, cur) => {
      const { created_at, payment_price } = cur;

      const date = dayjs.unix(created_at).format('YYYY-MM-DD');

      if (acc[date]) {
        acc[date] = {
          TOTAL: acc[date]['TOTAL'] + payment_price,
        };
      } else {
        acc[date] = {
          TOTAL: payment_price,
        };
      }

      return acc;
    }, {});

    const mappingData = Object.entries(dateData)
      .map(([key, value]) => ({
        key,
        ...value,
      }))
      .sort((a, b) => dayjs(b.key) - dayjs(a.key));

    return mappingData
      .slice(0, slice)
      .sort((a, b) => dayjs(a.key) - dayjs(b.key));
  }, [data, slice]);

  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={500}
        data={chartData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="key" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="TOTAL" stackId="a" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComp;
